<ngb-toast *ngFor="let toast of _toastService.toasts"
    [header]="toast.header"
    [autohide]="true"
    [delay]="toast.delay || 50000"
    (hidden)="_toastService.remove(toast)"
    [class]="toast.classname"
    style="font-weight: 600;">
    {{toast.textOrTpl}}
    <!-- <ng-template #text>{{ toast.textOrTpl }}</ng-template> -->
</ngb-toast>